import React from 'react';

import Modal from 'react-modal';

/** components */
import CustomTooltip from './CustomTooltip';
import ExternalRef from './ExternalRef';

/** helpers */
import { sanitizeHtml } from '../../helpers/format';

const CustomCheckbox = ({
  data,
  field,
  dataError,
  handleChange,
  fieldClassName,
  toggleFieldModal,
  isModalOpen,
}) => {
  return (
    <div key={'checkbox' + field.name} className={`${fieldClassName} formCustomCheckBox`}>
      <div className="form-field ">
        <label htmlFor={field.name}>
          <input
            id={field.name}
            checked={data[field.name]}
            name={field.name}
            onChange={(e) => handleChange(e, field.name, field)}
            type="checkbox"
            className={dataError[field.name] ? 'error' : ''}
          />
          <span
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(field.label) }}
            onClick={() => toggleFieldModal(field.name)}
          ></span>{' '}
          &nbsp;
          <ExternalRef field={field} />
          <CustomTooltip field={field} />
        </label>
        {field.modalContent && (
          <Modal
            isOpen={isModalOpen[field.name]}
            className="field-modal"
            contentLabel={field.modalContent}
          >
            <span onClick={() => toggleFieldModal(field.name)}>x</span>
            <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(field.modalContent) }}></div>
            <div className="btn-line">
              <button onClick={() => toggleFieldModal(field.name)} className="btn">
                OK
              </button>
            </div>
          </Modal>
        )}
      </div>

      {dataError[field.name] && <p className="error-text">{dataError[field.name]}</p>}
    </div>
  );
};

export default CustomCheckbox;
